import React, { useState, useContext } from 'react';
import { ThemeContext } from '../theme';
import ProfileTabBar from '../components/ProfileTabBar';
import InputField from '../components/InputField';
import SelectField from '../components/SelectField';
import KeywordInputField from '../components/KeywordInputField';
import Button from '../components/Button';

// Same DP used in SelectProfileScreen / ManageProfileScreen
const KIRAZ_URL = 'https://res.cloudinary.com/dcnujnpbm/image/upload/q_auto/f_auto/v1776961469/kiraz_dp_gs0phi.webp';

const SCALE = 0.75;
const sc = (n) => Math.round(n * SCALE);

const AGE_OPTIONS    = ['2-5', '6-10', '11-16'];
const GENDER_OPTIONS = ['Boy', 'Girl', 'Prefer not to say'];

export default function EditKidProfileScreen({ onTabChange, onSave }) {
  const theme = useContext(ThemeContext);
  const [profileName, setProfileName] = useState('Kiraz');
  const [age,         setAge]         = useState('');
  const [gender,      setGender]      = useState('');
  const [interests,   setInterests]   = useState(['Football', 'Cooking', 'Art', 'Reading']);

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', backgroundColor: theme.bg100, overflow: 'hidden' }}>

      {/* Rounded card */}
      <div
        style={{
          flex: 1,
          margin: sc(16),
          backgroundColor: theme.cardBg,
          borderRadius: sc(30),
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <ProfileTabBar active="manage-profile" onTabChange={onTabChange} />

        {/* Scrollable form body */}
        <div
          style={{
            flex: 1,
            overflowY: 'auto',
            padding: `${sc(28)}px ${sc(40)}px ${sc(36)}px`,
            display: 'flex',
            flexDirection: 'column',
            gap: sc(24),
          }}
        >
          {/* ── Photo row ── */}
          <div style={{ display: 'flex', alignItems: 'center', gap: sc(24) }}>
            <img
              src={KIRAZ_URL}
              alt="Kiraz"
              style={{
                width: sc(120),
                height: sc(120),
                borderRadius: '50%',
                objectFit: 'cover',
                flexShrink: 0,
              }}
            />

            <div style={{ display: 'flex', flexDirection: 'column', gap: sc(12) }}>
              <Button variant="tertiary" scale={SCALE} style={{ width: sc(154) }}>
                Upload
              </Button>
              <span
                className="font-satoshi"
                style={{ fontSize: sc(16), lineHeight: `${sc(24)}px`, color: theme.text400, fontWeight: 500 }}
              >
                At least 500 x 500px PNG or JPF file
              </span>
            </div>

            <div style={{ flex: 1 }} />

            <Button variant="primary" onClick={onSave} scale={SCALE} style={{ minWidth: sc(148) }}>
              Save
            </Button>
          </div>

          {/* ── Personal Information ── */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: sc(20) }}>
            <h2
              className="font-satoshi font-bold"
              style={{ margin: 0, fontSize: sc(22), lineHeight: `${sc(32)}px`, color: theme.text100 }}
            >
              Personal Information
            </h2>

            {/* Profile Name | Age | Gender */}
            <div style={{ display: 'flex', gap: sc(20) }}>
              <InputField
                label="Profile Name"
                required
                value={profileName}
                onChange={e => setProfileName(e.target.value)}
                scale={SCALE}
              />
              <SelectField
                label="Age"
                required
                options={AGE_OPTIONS}
                value={age}
                onChange={setAge}
                placeholder="Select age"
                scale={SCALE}
              />
              <SelectField
                label="Gender"
                options={GENDER_OPTIONS}
                value={gender}
                onChange={setGender}
                placeholder="Select gender"
                scale={SCALE}
              />
            </div>

            {/* Interests */}
            <KeywordInputField
              label="Interests"
              tags={interests}
              onChange={setInterests}
              scale={SCALE}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
